<template>
  <div v-if="alertText && dismissCountDown !== 0" class="col-auto alertPosition alertVue" :class="alertClass">
    <b-alert :show="dismissCountDown" dismissible :variant="alertVariant" fade @dismissed="resetAlert" @dismiss-count-down="countDownChanged">
      <div class="row">
        <div v-if="alertIcon" class="col-auto pr-0">
          <i class="fas" :class="'fa-' + alertIcon + ' '" />
        </div>

        <div class="pr-0" :class="alertIcon ? 'col-11' : 'col'">
          <h5 class="d-inline-flex">{{ alertTitle }}</h5>
          <p v-safe-html="alertText" />
          <!--<p v-else>{{ alertText }}</p>-->
        </div>
      </div>

      <template slot="dismiss">
        <span aria-hidden="true">
          <img src="../../../public/src/images/icon-modal-close.svg" alt="icon-modal-close" />
        </span>
      </template>
    </b-alert>
  </div>
</template>

<script>
export default {
  name: "BaseAlert",
  props: {
    alertClass: {
      type: String,
      default: null,
    },
    isItHtmlText: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    alertTitle: {
      get() {
        return this.$store.getters.getAlertTitle;
      },
    },
    alertText: {
      get() {
        return this.$store.getters.getAlertText;
      },
      set(val) {
        this.$store.commit("setAlertText", val);
      },
    },
    alertVariant: {
      get() {
        return this.$store.getters.getAlertVariant;
      },
    },
    dismissCountDown: {
      get() {
        return this.$store.getters.getDismissCountDown;
      },
      set(value) {
        this.$store.commit("setDismissCountDown", value);
      },
    },
    alertIcon: {
      get() {
        return this.$store.getters.getAlertIcon;
      },
    },
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
      if (dismissCountDown === 0) {
        this.resetAlert();
      }
    },
    resetAlert() {
      this.$store.commit("setAlertText", "");
      this.$store.commit("setAlertTitle", "");
      this.$store.commit("setAlertVariant", "");
      this.$store.commit("setAlertIcon", "");
      this.$store.commit("setDismissCountDown", 0);
    },
  },
};
</script>

<style scoped>
.alertPosition p {
  overflow-wrap: break-word;
  max-height: 500px;
  overflow-y: auto;
  padding-right: 15px;
}

.alertCustomZIndex {
  z-index: 9999;
}

.alertPosition {
  left: 0;
  right: 0;
  margin: 0 auto;
  width: max-content;
}
</style>
